<template>
  <!--  <router-view v-if="$route.name !== 'phonebook'" @fetch="fetchContacts()"/>-->

  <v-card class="pa-4" flat>
    <v-tabs v-model="tabs" grow>
      <v-tab>
        <v-icon right>mdi-format-list-numbered</v-icon>
        لیست
      </v-tab>

      <v-tab> یادآوری </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tabs">
      <v-tab-item>
        <dashboard-contacts />
      </v-tab-item>

      <v-tab-item disabled>
        <template v-if="!!tagList.length">
          <v-window v-model="selectedTag" vertical>
            <v-window-item v-for="n in tagList" :key="n.id">
              <v-card class="phone-list-bg rounded-lg" flat height="120">
                <v-row
                  align="center"
                  class="fill-height"
                  justify="center"
                  no-gutters
                >
                  <div class="text-center white--text">
                    <h2 style="font-size: 5rem">{{ n.name }}</h2>
                    <span v-if="isSharedPhonebook" class="ma-2 font-small"
                      >اشتراک گذاشته شده</span
                    >
                  </div>
                </v-row>
              </v-card>
            </v-window-item>
          </v-window>

          <v-card
          disabled="loading" :loading="loading" 
            class="d-flex justify-center justify-md-space-between pa-2"
            flat
          >
            <v-btn
              :disabled="tagList.length <= 1"
              class="d-none d-md-block"
              color="#B71C1C"
              icon
              @click="prev(selectedTag)"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>

            <div class="d-flex align-start">
              <v-menu
                :close-on-content-click="false"
                content-class="rounded-lg"
                min-width="200"
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :color="tagList.length ? '#FF4400' : 'success'"
                    class="mx-1"
                    dark
                    depressed
                    fab
                    v-bind="attrs"
                    x-small
                    v-on="on"
                  >
                    <v-icon
                      >mdi-{{
                        tagList.length ? "dots-vertical" : "plus"
                      }}</v-icon
                    >
                  </v-btn>
                </template>

                <v-card>
                  <contacts-tags :tag-list.sync="tagList" @reload="fetchTags" />
                </v-card>
              </v-menu>

              <v-item-group v-model="selectedTag" class="tag-items" mandatory>
                <v-item
                  v-for="(n, i) in tagList"
                  :key="n.id"
                  v-slot="{ active, toggle }"
                  class="mx-1 mb-2"
                >
                  <v-btn
                    :color="active ? '#FF4400' : ''"
                    :dark="active"
                    :input-value="active"
                    depressed
                    @click="selectItem(i)"
                  >
                    <v-icon v-if="n.hasOwnProperty('owner_id')" left
                      >mdi-share-all-outline</v-icon
                    >
                    {{ n.name }}
                  </v-btn>
                </v-item>
              </v-item-group>
            </div>

            <v-btn
              :disabled="tagList.length <= 1"
              class="d-none d-md-block"
              color="#B71C1C"
              icon
              @click="next(selectedTag)"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </v-card>
        </template>

        <v-card
          v-else
          class="d-flex flex-column align-center justify-center"
          flat
        >
          <v-img
            aspect-ratio="1"
            class="rounded-lg"
            contain
            src="/media/img/noPhoneTags.webp"
            width="160"
          />
          <v-card-title>
            لطفا ابتدا دفترچه تلفن جدید اضافه نمایید.
          </v-card-title>
          <v-card-actions class="justify-center">
            <contacts-tags is-btn @reload="fetchTags" />
          </v-card-actions>
        </v-card>

        <v-card :disabled="!tagList.length" flat>
          <v-card-title class="font-size-h1">
            <span
              v-if="
                !!tagList && !!tagList[selectedTag] && tagList[selectedTag].name
              "
            >
              {{ tagList[selectedTag].name || "مخاطبین" }}
            </span>
            <span
              v-if="!!data.data && !!data.data.length"
              class="font-size-h6 mx-1 grey--text"
              >({{ data.total }})</span
            >

            <v-btn
              v-if="hasPhonebookPermission('add')"
              class="mx-2 rounded-lg"
              color="success"
              outlined
              @click="goto('phonebook/create')"
            >
              <v-icon left>mdi-plus</v-icon>
              افزودن مشتری
            </v-btn>

            <v-spacer />
            <contacts-menu
              :phone-tag="tagList[selectedTag]"
              :selected-ids="selectedRows"
              @reload="reloadTable()"
            />
          </v-card-title>

          <v-divider v-if="!loading || !loadPhones" class="mt-0 mb-1" />
          <v-progress-linear v-else indeterminate />
          <template v-if="!loadPhones">
          <contacts-table
            v-if="loadPhones || (data && data.data && data.data.length > 0)"
            v-model="selectedRows"
            :data="data"
            :loading.sync="loadPhones"
            :table-props.sync="tableProps"
            @reload="reloadTable"
            @select="selectRow"
          />

          <template v-else>
            <v-img
              class="mt-3 mx-auto"
              contain
              max-height="150"
              max-width="150"
              src="media/empty/add-number-2.webp"
            />

            <p class="mt-2 text-center">
              <span class="font-weight-bold">{{ $t("LISTS.AddANumber") }}</span>
            </p>
          </template>
          </template>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <reminders />
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import { debounce } from "@/main";
import ContactsMenu from "@/view/content/contacts/contactsMenu.vue";
import ContactsTable from "@/view/content/contacts/contactsTable.vue";
import ContactsNumberView from "../../content/contacts/contactsNumberView.vue";
import NewContact from "./view/newContact.vue";
import ContactsTags from "../../content/contacts/contactsTags.vue";
import ContactImportFromExcel from "@/view/content/contacts/contactImportFromExcel.vue";
import { mapActions, mapState, mapGetters } from "vuex";
import reminders from "@/view/pages/reminders/index.vue";
import DashboardContacts from "@/core/plugins/TitleRibbon/components/contacts/contacts.vue";
// import DashboardContacts from "terminaladsribbon/components/contacts/contacts.vue"

export default {
  name: "contactsIndex",

  components: {
    ContactImportFromExcel,
    ContactsTags,
    NewContact,
    ContactsNumberView,
    ContactsTable,
    ContactsMenu,
    reminders,
    DashboardContacts,
  },

  data() {
    return {
      data: {},
      loading: false,
      loadPhones: false,
      tProps: {
        search: "",
        filters: {},
        status: null,
        length: 25,
        column: "id",
        dir: "desc",
        phone_tag_ids: [],
        page: 1,
      },
      tabs: 0,
      tabItems: [
        // {text: 'لیست', icon: 'format-list-numbered'},
        { text: "افزودن تکی", icon: "account-plus" },
        { text: "افزودن گروهی", icon: "phone-plus" },
        { text: "افزودن اکسل", icon: "file-excel" },
      ],
      tagList: [],
      selectedRows: [],
      toggle: 1,
      selectedTag: 0,
    };
  },

  created() {
    // this.fetchTags()
  },

  computed: {
    ...mapState("locals", ["selectedPhonebook"]),
    ...mapGetters("phonebook", ["isSharedPhonebook"]),
    tableProps: {
      get() {
        return {
          ...this.tProps,
          phone_tag_ids: [this.tagList[this.selectedTag]?.id || 0],
        };
      },
      set(val) {
        this.tProps = {
          ...val,
          phone_tag_ids: [this.tagList[this.selectedTag].id || 0],
        };
      },
    },
  },

  watch: {
    "$route.name"(val) {
      if (val === "contacts") this.fetchTags();
    },
    toggle(val) {
      if (!!val) {
        let temp = this.data;
        this.data = {};
        this.$nextTick(() => {
          setTimeout(() => {
            this.data = temp;
          }, 500);
        });
      }
    },
  },

  methods: {
    ...mapActions("locals", ["setSelectedPhonebook"]),
    ...mapActions("phonebook", ["setPhonebooksList", "setActivePhonebook"]),
    fetchTags() {
      this.loading = true;

      this.requestApiGetPayamak("phoneTag")
        .then(({ data }) => {
          this.tagList = data.data;
          this.setPhonebooksList(data.data);

          if (
            !isNaN(this.selectedPhonebook) &&
            this.selectedPhonebook != null
          ) {
            const activeIndex = data.data.findIndex(
              (item) => item.id === this.selectedPhonebook
            );
            this.selectedTag = activeIndex;
            this.setActivePhonebook(activeIndex);
          } else this.setActivePhonebook(this.selectedTag);

          this.$nextTick(() => {
            this.fetchContacts(this.tableProps, "create");
          });
        })
        .catch(({ response }) =>
          console.log("failed in get phone tags: ", response)
        )
        .finally(() => (this.loading = false));
    },
    fetchContacts(params = this.tableProps, from) {
      this.setSelectedPhonebook(params.phone_tag_ids[0]);

      this.loadPhones = true;
      this.selectedRows = [];

      this.requestApiGetPayamak("contact", params)
        .then(({ data }) => {
          this.data = data.data;
        })
        .catch(({ response }) => console.log("error in contacts: ", response))
        .finally(() => (this.loadPhones = false));
    },
    reloadTable(props) {
      debounce(() => this.fetchContacts(props, "reload table"), 1000);
    },
    selectRow(data) {
      if (!this.hasPhonebookPermission("edit")) return;

      this.setSelectedPhonebook(this.tagList[this.selectedTag].id);
      this.goto(`phonebook/edit/${data.phone}?change=${data.name}`);
    },
    selectItem(index) {
      this.selectedTag = index;
      this.setActivePhonebook(index);

      this.$nextTick(() => {
        this.fetchContacts({
          ...this.tableProps,
          phone_tag_ids:
            this.tagList[index].id >= 0
              ? [this.tagList[index].id]
              : [this.tagList[0].id],
        });
      });
    },
    next(index) {
      let sel = index + 1 === this.tagList.length ? 0 : index + 1;

      this.selectItem(sel);
    },
    prev(index) {
      let sel = index - 1 < 0 ? this.tagList.length - 1 : index - 1;

      this.selectItem(sel);
    },
    importFromBulk(e) {
      this.loading = true;

      this.requestApiPostPayamak("contact/store", {
        groupInsert: true,
        phone: e.join(","),
        phone_tags: [this.tagList[this.selectedTag].id],
      })
        .then(({ data }) => {
          this.$toast.success(data.message ?? "با موفقیت اضافه شد");
          this.fetchContacts();
          this.$refs.numberView.removeBulks();
        })
        .catch(({ response }) => {
          this.$toast.error(response.message ?? "خطا در افزودن شماره");
          console.log("failed to add bulk numbers: ", response);
        })
        .finally(() => (this.loading = false));
    },
  },

  beforeDestroy() {
    this.setSelectedPhonebook(null);
  },
};
</script>

<style scoped>
.phone-list-bg {
  background: linear-gradient(
    59deg,
    rgb(255 68 0),
    rgb(255 129 0),
    rgb(255 194 56)
  );
}

.tag-items >>> .v-btn {
  letter-spacing: normal !important;
}
</style>
